/* nimbus-pdp.js
 * Product page interactions:
 *  1. Pre-order logic — unavailable variant → "PRE ORDER" + line-item property
 *  2. Inline review slider — auto-rotation every 5 seconds
 *  3. Grain sections init
 */
(function () {
  'use strict';

  /* ─── 1. PRE-ORDER LOGIC ──────────────────────────────────────────── */
  function initPreorder() {
    var productInfo = document.querySelector('product-info[data-section]');
    if (!productInfo) return;

    var sectionId   = productInfo.dataset.section;
    var submitBtn   = document.getElementById('ProductSubmitButton-' + sectionId);
    var productForm = document.getElementById('product-form-' + sectionId);
    if (!submitBtn || !productForm) return;

    // Create pre-order message element
    var msg = document.createElement('div');
    msg.className = 'nb-preorder-msg';
    msg.innerHTML =
      '<svg width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" viewBox="0 0 24 24">' +
        '<circle cx="12" cy="12" r="10"/>' +
        '<line x1="12" y1="8" x2="12" y2="12"/>' +
        '<line x1="12" y1="16" x2="12.01" y2="16"/>' +
      '</svg>' +
      '<span>This product is temporarily out of stock — your order will ship as soon as it\'s available.</span>';

    // Hidden input for pre-order line item property
    var hiddenInput = document.createElement('input');
    hiddenInput.type  = 'hidden';
    hiddenInput.name  = 'properties[_pre_order]';
    hiddenInput.value = 'true';

    // Cart note attribute for order tagging
    var noteInput = document.createElement('input');
    noteInput.type  = 'hidden';
    noteInput.name  = 'attributes[pre_order]';
    noteInput.value = 'true';

    submitBtn.parentNode.insertAdjacentElement('afterend', msg);

    function updateState() {
      var variantId = productForm.querySelector('[name="id"]');
      if (!variantId) return;

      var selectedVariant = window.__st && window.__st.p_id;
      // Check availability via Dawn's variant data
      var variantData = productForm.querySelector('variant-radios, variant-selects');
      var isUnavailable = submitBtn.hasAttribute('disabled') ||
                         submitBtn.classList.contains('disabled') ||
                         submitBtn.textContent.toLowerCase().includes('sold out') ||
                         submitBtn.textContent.toLowerCase().includes('uitverkocht');

      if (isUnavailable) {
        submitBtn.querySelector('.btn-add-text, span:not(.loading__spinner)') &&
          (submitBtn.querySelector('.btn-add-text, span:not(.loading__spinner)').textContent = 'Pre-order');
        msg.classList.add('is-visible');
        // Add pre-order properties if not already present
        if (!productForm.querySelector('[name="properties[_pre_order]"]')) {
          productForm.appendChild(hiddenInput);
          productForm.appendChild(noteInput);
        }
      } else {
        msg.classList.remove('is-visible');
        // Remove pre-order properties
        var existing = productForm.querySelector('[name="properties[_pre_order]"]');
        if (existing) existing.remove();
        var existingNote = productForm.querySelector('[name="attributes[pre_order]"]');
        if (existingNote) existingNote.remove();
      }
    }

    // Watch for variant changes (Dawn dispatches 'change' on variant picker)
    productForm.addEventListener('change', function () {
      setTimeout(updateState, 100);
    });

    // Also observe button text changes (Dawn updates button on variant change)
    if ('MutationObserver' in window) {
      var obs = new MutationObserver(function () { updateState(); });
      obs.observe(submitBtn, { childList: true, subtree: true, characterData: true, attributes: true });
    }

    updateState();
  }

  /* ─── 2. INLINE REVIEW SLIDER ────────────────────────────────────── */
  function initInlineReviews() {
    document.querySelectorAll('.nb-inline-reviews').forEach(function (container) {
      var items  = Array.from(container.querySelectorAll('.nb-review-item'));
      var dots   = Array.from(container.querySelectorAll('.nb-review-dot'));
      var prev   = container.querySelector('[data-dir="prev"]');
      var next   = container.querySelector('[data-dir="next"]');
      if (!items.length) return;

      var current = 0;
      var timer   = null;

      function show(i) {
        current = ((i % items.length) + items.length) % items.length;
        items.forEach(function (el, j) { el.classList.toggle('is-active', j === current); });
        dots.forEach(function (d, j)   { d.classList.toggle('is-active', j === current); });
      }

      function startAuto() {
        timer = setInterval(function () { show(current + 1); }, 5000);
      }
      function stopAuto()  { clearInterval(timer); }

      if (prev) prev.addEventListener('click', function () { stopAuto(); show(current - 1); startAuto(); });
      if (next) next.addEventListener('click', function () { stopAuto(); show(current + 1); startAuto(); });
      dots.forEach(function (d) {
        d.addEventListener('click', function () { stopAuto(); show(parseInt(d.dataset.dot, 10)); startAuto(); });
      });

      container.addEventListener('mouseenter', stopAuto);
      container.addEventListener('mouseleave', startAuto);

      show(0);
      startAuto();
    });
  }

  /* ─── 3. GRAIN SECTIONS ──────────────────────────────────────────── */
  function initGrainSections() {
    ['.nb-outcomes', '.nb-feature-grid', '.nb-results', '.nb-training-logistics'].forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) { el.classList.add('nb-grain'); });
    });
  }

  /* ─── Bootstrap ──────────────────────────────────────────────────── */
  function init() {
    initPreorder();
    initInlineReviews();
    initGrainSections();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
